<template>
  <b-card>
      <div slot="header">
          <i class="fa fa-list-ul" aria-hidden="true"></i>
              {{text.notificationOneAppForm}}
          <div class="card-header-actions">
              <a href="https://bootstrap-vue.js.org/docs/components/progress" class="card-header-action" rel="noreferrer noopener" target="_blank">
              <small class="text-muted">{{text.docs}}</small>
              </a>
          </div>
      </div>

      <b-alert class="text-center" :show="sendNotiErrorMessage != ''" variant="danger"> {{ sendNotiErrorMessage }} </b-alert>

          <!-- Title -->
          <b-form-group>
            <label>{{text.title}}</label>
            <b-input-group>
                <b-input v-model="notification.title" :placeholder="text.pleaseEnterTitle"></b-input>
            </b-input-group>
          </b-form-group>

            <!-- Message -->
          <b-form-group>
            <label>{{text.message}}</label>
            <b-input-group>
              <b-form-textarea
                v-model="notification.message"
                :placeholder="text.pleaseEnterMessage"
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-input-group>
          </b-form-group>

          <!-- platform -->
        <b-form-group>
          <label>{{text.platform}}</label>
          <b-form-radio-group v-model="notification.to.platform">
            <b-form-radio value="all">All</b-form-radio>
            <b-form-radio value="ios">IOS</b-form-radio>
            <b-form-radio value="android">Android</b-form-radio>
          </b-form-radio-group>
        </b-form-group>

        <b-form-group v-show="mode !== 'production'">
          <label>Is Production</label> <font class="hint">* Show only dev.</font>
          <b-form-radio-group v-model="notification.to.production" :options="optionsProduction">
          </b-form-radio-group>
        </b-form-group>

        <!-- value -->
        <b-form-group>
          <label>{{text.to}}</label>
          <b-input-group>
            <v-select class="select-condition w-30" v-model="notification.to.type"  :options="['token', 'email', 'project']"></v-select>
            <v-select class="select-condition w-70"
              v-model="notification.to.value"
              multiple
              taggable
              :maxHeight="'200px'"
              :options="optionsNotification"
              :placeholder="text.pleaseInsertValues">
            </v-select>
          </b-input-group>
        </b-form-group>

      <div slot="footer">
        <b-button @click="$router.go(-1)" class="mr-2" size="sm" variant="secondary">
          <i class="fa fa-angle-left" aria-hidden="true"></i>
          {{text.back}}
        </b-button>
        <b-button :disabled="!isActive" @click="sendNotification" class="mr-2" size="sm" variant="primary">
          <i class="fa fa-paper-plane"></i>
          {{text.sendNow}}
        </b-button>
      </div>

      <!-- Modal notification  -->
      <b-modal
            ref="modal-notification-success"
            :title="text.sendNotification"
            size="lg"
            scrollable
            button-size="sm"
            centered
            header-class="p-2 border-bottom-0"
            footer-class="p-2 border-top-0"
            ok-only
            ok-variant="success"
            >
            {{text.sendNotificationSuccess}}
            <b-button
              variant="ghost-dark"
              size="sm"
              v-b-toggle.collapse-result
            >
              {{text.seeMoreDetails}}<i class="fa fa-caret-down" aria-hidden="true"></i>
            </b-button>
              <b-collapse id="collapse-result">
                <b-card>
                  {{ notificationResult }}
                </b-card>
              </b-collapse>
        </b-modal>
  </b-card>
</template>

<script>
import vSelect from 'vue-select';
import { ProjectList } from '../../../models/project-list';
import { textOneAppMessaging } from '@/assets/utils/language';

export default {
  data () {
    return {
      notification: {
        to: {
          platform: 'all',
          type: 'token',
          value: [],
          production: true
        },
        title: '',
        message: '',
        projectList: []
      },
      optionsNotification: [],
      isActive: true,
      sendNotiErrorMessage: '',
      mode: process.env.VUE_APP_MODE,
      optionsProduction: [{ text: 'True', value: true }, { text: 'False', value: false }],
      notificationResult: {},
      text: {}
    };
  },
  methods: {
    sendNotification () {
      this.isActive = false;
      // ** map before send ** //
      if ('project' === this.notification.to.type) {
        this.notification.to.type = 'tag';
        this.notification.to.value = this.notification.to.value.map(v => v.code);
      } else if ('email' === this.notification.to.type) {
        this.notification.to.type = 'refId';
      }

      const jsonBody = {
        to: this.notification.to,
        title: this.notification.title,
        message: this.notification.message
      };

      this.axios.post(process.env.VUE_APP_URL_MESSAGING_API + '/notification/send-one-app', jsonBody)
        .then(response => {
          this.sendNotiErrorMessage = '';
          this.notification = {
            title: '',
            message: '',
            to: {
              platform: 'all',
              type: 'token',
              value: [],
              production: true
            }
          };
          this.notificationResult = response.data.data.result;
          this.$refs['modal-notification-success'].show();
        })
        .catch(error => {
          this.sendNotiErrorMessage = error.response && error.response.data && error.response.data.data ? error.response.data.data : error.message;
        })
        .finally(() => {
          this.isActive = true;
        });
    }
  },
  components: {
    'v-select': vSelect
  },
  watch: {
    'notification.to.type' (to, from) {
      console.log(this.projectList);
      if ('project' === to) {
        this.optionsNotification = this.projectList;
      } else {
        this.optionsNotification = [];
      }
    },
    $language: function () {
      this.text = textOneAppMessaging(this.$language);
    }
  },
  mounted () {
    this.projectList = (new ProjectList()).getProjectSelectDrobdownObject();
    this.text = textOneAppMessaging(this.$language);
  }
};
</script>

<style scoped>
  .thumbnail{
        max-width: 100px;
    }
  .hint{
    font-size: 9px;
    color: #f86c6b;
  }
</style>
<style>
    .pagination {
        margin-left: auto;
        margin-right: auto;
    }
    .users-filter .vs__search::placeholder,
    .users-filter .vs__dropdown-toggle,
    .users-filter .vs__dropdown-menu {
        color: #394066;
        font-variant: small-caps;
        border: 1px solid #e4e7ea;
    }
    .vs__dropdown-menu{
      max-height: 150px !important;
    }
    .filter-status {
        margin-top: 1px;
    }
    .w-30{
    width: 30% !important;
    }
    .w-70{
      width: 70% !important;
    }
</style>
